// extracted by mini-css-extract-plugin
export default {"searchFieldContainer":"oQYOWo2v4qzDcRpYA87z","leadingIcon":"PvkO5KcYi3prt15Xjnz3","searchField":"wY6LBBxJ9WzbIqHbsAmM","xStyles":"KtcXhrdOcOsccQT3hpGI"};